import { render, staticRenderFns } from "./FavouriteListing.vue?vue&type=template&id=4b252ef3&"
import script from "./FavouriteListing.ts?vue&type=script&lang=ts&"
export * from "./FavouriteListing.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports